import { z } from 'zod'

/**
 * 入退室メッセージ（Geofence）ドメインのスキーマ。
 * バックエンド #3259（`GeofenceAreaController`）の API 契約に対応する。
 */

export const GeofenceEventTypeEnum = z.enum(['enter', 'exit'])
export type GeofenceEventType = z.infer<typeof GeofenceEventTypeEnum>

// ─────────────────────────────────────────────
// GET /api/v2/geofence-areas
// ─────────────────────────────────────────────
export const GeofenceAreaDataSchema = z.object({
  id: z.number(),
  name: z.string(),
  /** 判定エリア中心の緯度 */
  latitude: z.number(),
  /** 判定エリア中心の経度 */
  longitude: z.number(),
  /** 判定半径（メートル） */
  radius: z.number(),
  enterTitle: z.string(),
  enterBody: z.string(),
  exitTitle: z.string(),
  exitBody: z.string(),
  /** 現在の会期で入室メッセージを表示済みか */
  entered: z.boolean(),
  /** 現在の会期で退出メッセージを表示済みか */
  exited: z.boolean(),
})
export type GeofenceAreaData = z.infer<typeof GeofenceAreaDataSchema>

export const GeofenceAreaListResponseSchema = z.object({
  /**
   * 入退室メッセージの評価対象期間内か。false のとき areas は必ず空。
   * true かつ areas が空なら判定エリア未登録＝GPS 監視を停止してよい。
   */
  active: z.boolean(),
  areas: z.array(GeofenceAreaDataSchema),
})
export type GeofenceAreaListResponse = z.infer<typeof GeofenceAreaListResponseSchema>

// ─────────────────────────────────────────────
// POST /api/v2/geofence-areas/{id}/events
// ─────────────────────────────────────────────
export const GeofenceEventResponseSchema = z.object({
  areaId: z.number(),
  type: GeofenceEventTypeEnum,
  /** 今回新たに記録したか（false は既に記録済みで冪等に無視） */
  recorded: z.boolean(),
  entered: z.boolean(),
  exited: z.boolean(),
})
export type GeofenceEventResponse = z.infer<typeof GeofenceEventResponseSchema>

/** POST /api/v2/geofence-areas/{id}/events リクエストボディ */
export type GeofenceEventRequest = {
  type: GeofenceEventType
  /** 記録時の緯度（サーバ側で半径内/外を検証） */
  latitude: number
  /** 記録時の経度（サーバ側で半径内/外を検証） */
  longitude: number
}
